import React from 'react'
import { useTranslation } from 'react-i18next'
import { TimePeriod } from '../../../utils/timePeriod'

export interface ChartTimeSwitchProps {
	timePeriod: TimePeriod
	setTimePeriod: (tp: TimePeriod) => void
}

const ChartTimeSwitch = ({ timePeriod, setTimePeriod }: ChartTimeSwitchProps) => {
	const { t } = useTranslation('pages_electricity')

	const { resolution } = timePeriod
	const setResolution = (resolution: 'day' | 'week' | 'month' | 'year') => {
		setTimePeriod({ ...timePeriod, resolution })
	}

	const defaultStyle =
		'option text-[#a3a3a3] dark:text-brand-primary-100-dark bg-white dark:bg-[#144448] hover'
	const selectedStyle =
		'option bg-brand-secondary-100-light text-white dark:bg-[#3cb49f] dark:text-background-200-dark cursor-default'

	return (
		<div className='switch-container bg-brand-secondary-200-light dark:bg-[#0d2d30] border border-[#d7d7d7] dark:border-[#063a3e]'>
			<div className='switch gap-1 bg-white dark:bg-[#144448]'>
				<div
					onClick={() => setResolution('day')}
					className={resolution === 'day' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.paiva')}
				</div>
				<div
					onClick={() => setResolution('week')}
					className={resolution === 'week' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.viikko')}
				</div>
				<div
					onClick={() => setResolution('month')}
					className={resolution === 'month' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.kuukausi')}
				</div>
				<div
					onClick={() => setResolution('year')}
					className={resolution === 'year' ? selectedStyle : defaultStyle}
				>
					{t('chartTimeSwitch.vuosi')}
				</div>
			</div>
		</div>
	)
}
export default ChartTimeSwitch
